(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-advertorial"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.adv2'); if(!root) return;
  var sws=root.querySelectorAll('.adv2__sw');
  var vid=root.querySelector('#adv-vid');
  var now=root.querySelector('#adv-now');
  var old=root.querySelector('#adv-old');
  var btnP=root.querySelector('#adv-btn-price');
  var stickyP=root.querySelector('#adv-sticky-price');
  var name=root.querySelector('#adv-sw-name');
  var hero=root.querySelector('#adv-buy-hero');
  var addBtn=root.querySelector('#adv-add');
  sws.forEach(function(sw){
    sw.addEventListener('click',function(){
      sws.forEach(function(s){s.classList.remove('is-on');s.setAttribute('aria-checked','false');});
      sw.classList.add('is-on'); sw.setAttribute('aria-checked','true');
      var d=sw.dataset;
      if(vid) vid.value=d.id;
      if(now) now.textContent=d.price;
      if(btnP) btnP.textContent=d.price;
      if(stickyP) stickyP.textContent=d.price;
      if(name) name.textContent=d.title;
      if(old) old.textContent=(d.compare&&d.compare!=='')?d.compare:'';
      if(hero && d.img) hero.src=d.img;
      if(addBtn){
        var avail=d.available==='true';
        addBtn.disabled=!avail;
        addBtn.style.opacity=avail?'1':'.55';
        if(!avail){ addBtn.innerHTML='Rupture de stock'; }
        else { addBtn.innerHTML='Ajouter au panier — <span id="adv-btn-price">'+d.price+'</span>'; }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-pdp-stories"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.currentScript.closest('.ch-stories') || document.querySelector('.ch-stories');
  if(!section) return;
  var cards = Array.prototype.slice.call(section.querySelectorAll('.ch-stories__card'));
  var modal = section.querySelector('.ch-stories__modal');
  var video = section.querySelector('.ch-stories__video');
  var closeBtn = section.querySelector('.ch-stories__close');
  var prevBtn = section.querySelector('.ch-stories__prev');
  var nextBtn = section.querySelector('.ch-stories__next');
  var current = 0;
  function open(i){
    current = (i + cards.length) % cards.length;
    video.src = cards[current].getAttribute('data-src');
    modal.hidden = false; modal.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden';
    var p = video.play(); if(p && p.catch) p.catch(function(){});
  }
  function close(){
    video.pause(); video.removeAttribute('src'); video.load();
    modal.hidden = true; modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
  }
  cards.forEach(function(c,i){ c.addEventListener('click', function(){ open(i); }); });
  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', function(){ open(current-1); });
  nextBtn.addEventListener('click', function(){ open(current+1); });
  modal.addEventListener('click', function(e){ if(e.target === modal) close(); });
  document.addEventListener('keydown', function(e){ if(!modal.hidden && e.key === 'Escape') close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
